import { Address } from '../client/src/models';
import { IAddress } from '@nx-ng/types';

export const mapAddressResponse = (address?: Address): IAddress => {
  return {
    address1: address?.line1 || '',
    address2: address?.line2 || '',
    town: address?.townCity || '',
    postCode: address?.postcode || '',
  };
};
